import dayjs from 'services/utils/dayjs'

export const levels = ['BEGINNERS', 'MIDDLES', 'ADVANCED', 'MIXED']

export const occurrences = ['ONCE', 'WEEKLY', 'MONTHLY']

export const days = dayjs.weekdays().map((day, index) => `${index + 1}`)
